import {
	FACEBOOK_LOGIN
} from '../actions/facebook-login';

const INITIAL_STATE = { 
    data: [], error: null
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {

        case FACEBOOK_LOGIN:// return list of posts and make loading = false
            return { ...state, data: action.payload, error:null };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer-facebook-login.js